var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('icon-svg-base',{staticClass:"icon",attrs:{"view-width":20,"view-height":20}},[_c('line',{staticClass:"icon__line",attrs:{"stroke-width":_vm.strokeWidth,"x1":"1","y1":"10","x2":"19","y2":"10"}})])}
var staticRenderFns = []

export { render, staticRenderFns }